import { IconName } from '@optimus-web/icons';
import { Icon } from '../Icon';
import { IconButton } from '../IconButton';
import { formatFileSize } from './helpers';
import { FileNameContainer, FileNameWrapper, FilesContainer } from './style';

interface FileContainerProps {
    clearFile: (file: File) => void;
    file: File;
}

export const FileContainer = ({ clearFile, file }: FileContainerProps) => (
    <FilesContainer key={file.name} data-test-file>
        <Icon value={IconName.FiscalReport} />
        <FileNameWrapper>
            <FileNameContainer as="div" variant="primary" textStyle="bodyMediumStrong">
                {file.name}
            </FileNameContainer>
            <FileNameContainer as="div" variant="tertiary" textStyle="bodySmall">
                {formatFileSize(file.size)}
            </FileNameContainer>
        </FileNameWrapper>
        <IconButton
            variant="ghost"
            icon={IconName.Delete}
            size="small"
            onClick={() => clearFile(file)}
            data-test-button-remove
            type="button"
        />
    </FilesContainer>
);
